import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";

const basePath = process.env.VUE_APP_PATH;

export default createRouter({
  history:
    process.env.VUE_APP_RENDER === "prerender"
      ? createWebHistory(basePath)
      : createWebHashHistory(basePath),
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        top: 86,
      };
    }
  },
  routes: [
    {
      path: "/",
      redirect: "/it/",
    },
    {
      path: "/:lang/",
      alias: "/:lang/index.html",
      name: "home",
      component: () => import("@/views/Landing.vue"),
    },
    {
      path: "/:lang/card/",
      alias: "/:lang/card/index.html",
      name: "card",
      component: () => import("@/views/CardYear.vue"),
    },
  ],
});
